export const NAME = 'assetPicker';
export const SEARCH_NAME = 'assetPicker';
